import { getStaticContent } from '/@/components/refuge/static-content';
import Title from '/@/components/title';
import { _ } from '/@/locale';
import styles from './styles.module.css';

export const Refuge = (props) => {
    const { type, country } = props;

    const ribLayout = getStaticContent('rib-layout-options', type, country);
    const goodPractices = getStaticContent('good-practices', type, country);
    const structuredLayout = getStaticContent('layout-options', type, country);

    if (!goodPractices && !ribLayout && !structuredLayout) return null;

    return (
        <div className={styles.root}>
            <Title size='xl' underline>
                {_('Refugio')}
            </Title>
            {structuredLayout && (
                <div className={styles.section}>
                    <div className={styles.title}>{_('Refugio estructurado')}</div>
                    {structuredLayout.render(country)}
                </div>
            )}
            {ribLayout && (
                <div className={styles.section}>
                    <div className={styles.title}>{_('Refugio en bolsa (RIB)')}</div>
                    {ribLayout.render(country)}
                </div>
            )}
            {goodPractices && (
                <div className={styles.goodPractices}>
                    <div className={styles.title}>{_('Buenas prácticas')}</div>
                    {goodPractices.render(country)}
                </div>
            )}
        </div>
    );
};
